/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../root/RootReducer";
import { UpdateUserList } from "../../user/User";
import { GetUserInfoList, UpdateUserInfo } from "../../user/UserActions";
import styles from "./EditUser.module.css";
import {
  Modal,
  Button,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Checkbox,
  Paper,
  IconButton,
  Avatar,
  CircularProgress,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import SelectSkill from "./SelectSkill";
import EditProfileImage from "../../common/components/modal/EditProfileImage";
import { filterUserList } from "../../viewer/presenters/PresentersActions";
import { GetRecommendProfessionalList } from "../../common/homePage/HomePageActions";
import PuiSelect from "../../components/elements/PuiSelect";
import { uniq, isEmpty } from "../../utils/ObjectUtils";
// import RefreshIcon from '@material-ui/icons/Refresh';
// import PuiTooltip from "../../components/elements/PuiTooltip ";
import PuiMessage from "../../components/widgets/PuiMessage";
import PuiFloatButton from "../../components/elements/PuiFloatButton";

// 表示用データ定義
interface UserData {
  id: string;
  imageUrl: string;
  imageFile: any;
  fullName: string;
  email: string;
  localAccountId: string;
  organization: string;
  lastLogin: string;
  skills: string[];
  isAdmin: boolean;
  isProf: boolean;
  isGuest: boolean;
}

interface EditUserProps {
  setIsSaved: (isSaved: boolean) => void;
  isSaved: boolean;
}

export default function EditUser({ setIsSaved, isSaved }: EditUserProps) {
  const dispatch = useDispatch();
  //APIコール
  useEffect(() => {
    dispatch(GetUserInfoList());
  }, [dispatch]);
  
  // バックエンドからユーザデータ取得
  const { initialUserList, isLoading, errorMessage } = useSelector(
    (state: AppState) => ({
      initialUserList: state.user.userInfoList,
      isLoading: state.user.isLoading,
      errorMessage: state.user.errorMessage,
    })
  );

  // 表示用データ
  // eslint-disable-next-line
  const [userData, ChangeUserData] = useState<UserData[]>([]);

  // メッセージ制御用
  const [showMessage, setShowMessage] = useState<boolean>(false);

  // 会社名選択
  const [companyList, ChangeCompanyList] = useState<string[]>(["会社を選択"]);
  const [visibleCompany, ChangeVisibleCompany] = useState("会社を選択");
  // const [isVisibleHeader, ChangeVisibleHeader] = useState(false);
  const PushCompanyName = (organization: string) => {
    companyList.push(organization);
    const tempList = uniq(companyList);
    // 会社リストの並び替え
    tempList.sort(function (a, b) {
      if (a === "会社を選択" || b === "会社を選択") return 0;
      if (a === "その他" && b === "未登録") return -1;
      if (a.toString().length < b.toString().length) {
        return 1;
      } else if (a.toString().length > b.toString().length) {
        return -1;
      }
      return 0;
    });
    ChangeCompanyList(tempList);
  };

  const ChooseCompany = (organization: string) => {
    ChangeVisibleCompany(organization);
  };

  // ユーザー管理画面をリフレッシュ
  // const refresh = () => {
  //     dispatch(StartSyncBatch())
  //     // TODO: temp
  //     // プロフェショナル一覧画面のrefresh
  //     const userFilter = {id:-1, skill:[], tag:[]}
  //     setTimeout(() => dispatch(filterUserList(userFilter)), 2000);
  //     setTimeout(() => dispatch(GetRecommendProfessionalList()), 2000);
  //     setShowMessage(true);
  //};
  // メッセージを閉じる
  const closeMsg = () => {
    setShowMessage(false);
  };

  // バックエンドデータから表示用データに変換
  const [isConvertDisplayData, ConvertDisplayDataFlag] = useState(false);
  initialUserList !== undefined &&
    isConvertDisplayData === false &&
    initialUserList.forEach(function (row) {
      if (Object.keys(userData).length < Object.keys(initialUserList).length) {
        userData.push({
          id: row.id,
          imageUrl: row.imageUrl,
          imageFile: null,
          fullName: row.fullName,
          email: row.email,
          localAccountId: row.localAccountId,
          organization: row.organization,
          lastLogin: row.lastLogin,
          skills: row.skills,
          isAdmin: row.roles.includes("ADMIN"),
          isProf: row.roles.includes("PRESENTER"),
          isGuest: row.roles.includes("GUEST"),
        });
        // 会社名をセット
        PushCompanyName(row.organization);
      }
      ConvertDisplayDataFlag(true);
      return null;
    });

  // プロファイル変更カウント
  const [profileEditNumber, CountProfileEdit] = useState(0);
  const [isLimitProfile, ChangeLimitProfile] = React.useState(false);

  useEffect(() => {
    if (profileEditNumber > 3) {
      ChangeLimitProfile(true);
    } else {
      ChangeLimitProfile(false);
    }
  }, [profileEditNumber]);

  // プロファイルコンポーンネントコールバック
  const ChangeProfileImage = (
    changeIndex: string,
    newImageUrl: string,
    newImageFile: any
  ) => {
    console.log(
      "changeIndex",
      changeIndex,
      "newImageUrl",
      newImageUrl,
      "newImageFile",
      newImageFile
    );
    userData[Number(changeIndex)]["imageUrl"] = "";
    userData[Number(changeIndex)]["imageUrl"] = newImageUrl;
    userData[Number(changeIndex)]["imageFile"] = newImageFile;
    // console.log("index", Number(changeIndex));
    // console.log("imageUrl", userData[Number(changeIndex)]["imageUrl"]);
    CountProfileEdit(profileEditNumber + 1);
    setIsSaved(false);
  };

  // ユーザAdmin権限変更
  const ChangeAdmin = (changeIndex: number, changeValue: boolean) => {
    userData[changeIndex]["isAdmin"] = !changeValue;
    setIsSaved(false);
  };

  // ユーザProfessional権限変更
  const ChangeProf = (changeIndex: number, changeValue: boolean) => {
    userData[changeIndex]["isProf"] = !changeValue;
    setIsSaved(false);
  };

  // ユーザGuest権限変更
  const ChangeGuest = (changeIndex: number, changeValue: boolean) => {
    userData[changeIndex]["isGuest"] = !changeValue;
    setIsSaved(false);
  };

  // --------------------スキル変更モーダル--------------------

  const [editUserId, SetEditUserId] = React.useState("-1");
  const [editUserName, SetEditUserName] = React.useState("");
  const [editUserSkills, ChangeEditUserSkills] = useState([""]);

  // スキル選択モーダル画面表示制御
  const [isOpenSkillSelectModal, ShowSkillSelectModal] = useState(false);
  const OpenSkillSelectModal = (openUserId: string, openUserName: string) => {
    ShowSkillSelectModal(true);
    ChangeEditUserSkills(
      userData[userData.findIndex(({ id }) => id === openUserId)]["skills"]
    );
    SetEditUserId(openUserId);
    SetEditUserName(openUserName);
  };

  const CloseSkillSelectModal = () => {
    ShowSkillSelectModal(false);
    ChangeEditUserSkills([""]);
  };

  const SetUserSkills = (updateSkillList: string[]) => {
    const changeIndex = userData.findIndex(({ id }) => id === editUserId);
    userData[changeIndex]["skills"] = updateSkillList;
    ChangeEditUserSkills(userData[changeIndex]["skills"]);
    // setIsSaved(false);
  };

  // --------------------削除モーダル--------------------
  // ユーザ削除モーダル画面表示制御
  const [isOpenDeleteUserModal, ShowDeleteUserModal] = React.useState(false);
  // const OpenDeleteUserModal = () => {
  //     ShowDeleteUserModal(true);
  //};
  const CloseDeleteUserModal = () => {
    ShowDeleteUserModal(false);
  };

  // ユーザ削除ボタン押下
  // const [deleteUser, ChangeDeleteUser] = React.useState({id: "", fullName: "", email: "", lastLogin: "", isAdmin: false, isProf: false, isGuest: false});
  const deleteUser = {
    id: "",
    fullName: "",
    email: "",
    lastLogin: "",
    isAdmin: false,
    isProf: false,
    isGuest: false,
  };

  // const ClickUserDeleteButton =(id: string) => {
  //     const targetUser = userData.find((row) => {
  //         return (row.id === id);
  //    });
  //     if(targetUser !== undefined){
  //         ChangeDeleteUser(targetUser);
  //         OpenDeleteUserModal();
  //    }
  //};

  // ユーザ削除
  const DeleteUser = () => {
    console.log("EditUser DeleteUser start");
    const deleteIndex = userData.findIndex(({ id }) => id === deleteUser.id);
    userData.splice(deleteIndex, 1);
    // ChangeUserData(newList);
    setIsSaved(false);
    CloseDeleteUserModal();
  };

  // ユーザ削除取り消し
  const CancelDeleteUser = () => {
    console.log("EditUser CancelDeleteUser start");
    CloseDeleteUserModal();
  };

  // ユーザ更新ボタン押下
  const comparisonUserData: UpdateUserList[] = [];
  const updateUserData: UpdateUserList[] = [];
  const sendUserData: UpdateUserList[] = [];
  const ClickUpdateButton = () => {
    console.log("EditUser ClickUpdateButton start");

    // バックエンドのユーザデータ変換
    initialUserList &&
      initialUserList.forEach(function (row) {
        comparisonUserData.push({
          id: row.id,
          imageFile: null,
          fullName: row.fullName,
          skills: row.skills,
          roles: row.roles,
        });
      });

    // 変更後のユーザデータ変換
    userData.forEach(function (row) {
      const role: string[] = [];

      if (row.isAdmin === true) {
        role.push("ADMIN");
      }
      if (row.isProf === true) {
        role.push("PRESENTER");
      }
      if (row.isGuest === true) {
        role.push("GUEST");
      }

      updateUserData.push({
        id: row.id,
        imageFile: row.imageFile,
        fullName: row.fullName,
        skills: row.skills,
        roles: role,
      });

      return null;
    });

    // 比較
    updateUserData.map(function (row, index) {
      if (
        JSON.stringify(row.skills) !==
          JSON.stringify(comparisonUserData[index]["skills"]) ||
        JSON.stringify(row.roles) !==
          JSON.stringify(comparisonUserData[index]["roles"]) ||
        JSON.stringify(row.imageFile) !==
          JSON.stringify(comparisonUserData[index]["imageFile"])
      ) {
        sendUserData.push({
          id: row.id,
          imageFile: row.imageFile,
          fullName: row.fullName,
          skills: row.skills,
          roles: row.roles,
        });
      }
      return null;
    });
    dispatch(UpdateUserInfo(sendUserData));
    ConvertDisplayDataFlag(false);
    setIsSaved(true);
    CountProfileEdit(0);
    ChangeLimitProfile(false);
    // TODO: temp
    // プロフェショナル一覧画面のrefresh
    const userFilter = { id: -1, skill: [], tag: [] };
    setTimeout(() => dispatch(filterUserList(userFilter)), 2000);
    setTimeout(() => dispatch(GetRecommendProfessionalList()), 2000);
  };

  // 各変数更新監視
  useEffect(() => {
    console.log("取得データ");
    console.log(initialUserList);
  }, [initialUserList]);
  useEffect(() => {
    console.log("表示用データ");
    console.log(userData);
  }, [userData]);
  useEffect(() => {
    console.log("送信用更新データ");
    console.log(sendUserData);
  }, [sendUserData]);

  // 表示待機
  if (isLoading) {
    return (
      <div className={styles.noContent}>
        <CircularProgress size={60} style={{ color: "var(--red)" }} />
      </div>
    );
  }

  return (
    <div className={styles.root}>
      {/* ユーザ追加ボタン */}
      {/* <IconButton><AddCircleRoundedIcon className={styles.addButton} style={{width:"40px", height:"40px",color:"var(--red)"}}/></IconButton> */}

      <div className={styles.selectCompany}>
        <PuiSelect
          defaultValue="会社を選択"
          childrens={companyList}
          onChange={ChooseCompany}
        />
        {/* <div className={styles.refreshButton} data-for="batch" data-tip={"ユーザー同期バッチを実行"}>
                    <PuiFloatButton children={[<RefreshIcon/>]} size="medium" onClick={refresh}/>
                </div>
                <PuiTooltip id="batch"/> */}
      </div>

      {/* ユーザ一覧リスト */}
      {visibleCompany !== "会社を選択" && (
        <TableContainer className={styles.table} component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow style={{ width: "100%" }}>
                {/* <TableCell style={{width:"40px",borderBottom: 0}}></TableCell> */}
                <TableCell
                  style={{ width: "65px", borderBottom: 0 }}
                ></TableCell>
                <TableCell
                  align="left"
                  style={{
                    minWidth: "20%",
                    fontSize: "12px",
                    textAlign: "center",
                    borderBottom: 0,
                    whiteSpace: "nowrap",
                  }}
                >
                  <h2>名前</h2>
                </TableCell>
                <TableCell
                  align="left"
                  style={{
                    minWidth: "15%",
                    fontSize: "12px",
                    textAlign: "center",
                    borderBottom: 0,
                    whiteSpace: "nowrap",
                  }}
                >
                  <h2>メールアドレス</h2>
                </TableCell>
                <TableCell
                  align="left"
                  style={{
                    minWidth: "15%",
                    fontSize: "12px",
                    textAlign: "center",
                    borderBottom: 0,
                    whiteSpace: "nowrap",
                  }}
                >
                  <h2>前回アクセス</h2>
                </TableCell>
                <TableCell
                  align="left"
                  style={{
                    minWidth: "20%",
                    fontSize: "12px",
                    textAlign: "center",
                    borderBottom: 0,
                    whiteSpace: "nowrap",
                  }}
                >
                  <h2>Skill</h2>
                </TableCell>
                <TableCell
                  align="center"
                  style={{ minWidth: "8%", fontSize: "12px", borderBottom: 0 }}
                >
                  <h2>Admin.</h2>
                </TableCell>
                <TableCell
                  align="center"
                  style={{ minWidth: "8%", fontSize: "12px", borderBottom: 0 }}
                >
                  <h2>Pre.</h2>
                </TableCell>
                <TableCell
                  align="center"
                  style={{ minWidth: "8%", fontSize: "12px", borderBottom: 0 }}
                >
                  <h2>Guest</h2>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {userData.map(
                (row, index) =>
                  row.organization === visibleCompany && (
                    <TableRow key={index} style={{ width: "100%" }}>
                      {/* <TableCell style={{borderBottom: 0}}><IconButton>
                                    <CancelIcon style={{width:"40px",height:"40px",color:"gray"}} onClick={() => ClickUserDeleteButton(row.id)}/>
                                </IconButton></TableCell> */}
                      <TableCell
                        style={{ borderBottom: 0, position: "relative" }}
                      >
                        <div>
                          <Avatar
                            src={row.imageUrl}
                            variant="circle"
                            style={{
                              height: "55px",
                              width: "55px",
                              backgroundColor: "white",
                            }}
                          />
                          <div className={styles.camera}>
                            <EditProfileImage
                              userid={String(index)}
                              fullname={row.fullName}
                              organization={row.organization}
                              localAccountId={row.localAccountId}
                              onCallback={ChangeProfileImage}
                            />
                          </div>
                        </div>
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          borderBottom: 0,
                          fontSize: "10px",
                          textAlign: "left",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <div
                          style={{ width: "100%" }}
                          className={styles.cellBottomBorder}
                        >
                          <h2>{row.fullName}</h2>
                        </div>
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          borderBottom: 0,
                          fontSize: "10px",
                          textAlign: "left",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <div
                          style={{ width: "100%" }}
                          className={styles.cellBottomBorder}
                        >
                          <h2>{row.email}</h2>
                        </div>
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          borderBottom: 0,
                          fontSize: "10px",
                          textAlign: "left",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <div
                          style={{ width: "100%" }}
                          className={styles.cellBottomBorder}
                        >
                          <h2>{row.lastLogin}</h2>
                        </div>
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          borderBottom: 0,
                          fontSize: "10px",
                          textAlign: "left",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <div
                          style={{ width: "100%", display: "flex" }}
                          className={styles.cellBottomBorder}
                        >
                          <h2>{Object.keys(row.skills).length}件</h2>
                          <IconButton
                            onClick={() =>
                              OpenSkillSelectModal(row.id, row.fullName)
                            }
                            className={styles.skillEditIcon}
                          >
                            <EditIcon
                              style={{
                                width: "20px",
                                height: "20px",
                                color: "var(--red)",
                              }}
                              color="secondary"
                            />
                          </IconButton>
                        </div>
                      </TableCell>
                      <TableCell align="center" style={{ borderBottom: 0 }}>
                        <Checkbox
                          color="default"
                          defaultChecked={row.isAdmin}
                          onChange={() => ChangeAdmin(index, row.isAdmin)}
                        />
                      </TableCell>
                      <TableCell align="center" style={{ borderBottom: 0 }}>
                        <Checkbox
                          color="default"
                          defaultChecked={row.isProf}
                          onChange={() => ChangeProf(index, row.isProf)}
                        />
                      </TableCell>
                      <TableCell align="center" style={{ borderBottom: 0 }}>
                        <Checkbox
                          color="default"
                          defaultChecked={row.isGuest}
                          onChange={() => ChangeGuest(index, row.isGuest)}
                        />
                      </TableCell>
                    </TableRow>
                  )
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* 更新ボタン */}

      {isLimitProfile && (
        <p className={styles.attention}>
          ※一度に多くのプロフィール画像を更新すると、更新に時間がかかる可能性があります。
        </p>
      )}
      {/* <Button size="small" variant="outlined" color="secondary" onClick={ClickUpdateButton}className={styles.updateButton} style={{position:"absolute"}}  disabled={isSaved}>更新</Button> */}
      <div className={styles.updateButton}>
        <PuiFloatButton
          children={["　更新　"]}
          size="medium"
          isActive={!isSaved}
          onClick={ClickUpdateButton}
        />
      </div>

      {/* スキル選択モーダル */}
      <Modal open={isOpenSkillSelectModal} onClose={CloseSkillSelectModal}>
        <SelectSkill
          userName={editUserName}
          in={isOpenSkillSelectModal}
          onClose={CloseSkillSelectModal}
          userSkills={editUserSkills}
          SetUserSkills={SetUserSkills}
          SetIsSaved={setIsSaved}
        />
      </Modal>

      {/* ユーザ情報削除モーダル */}
      <Modal open={isOpenDeleteUserModal} onClose={CloseDeleteUserModal}>
        <div
          style={{
            backgroundColor: "white",
            width: "600px",
            height: "40%",
            margin: "10vh auto auto auto",
          }}
        >
          <ul className={styles.ul}>
            <li>名前：{deleteUser.fullName}</li>
            <li>メールアドレス：{deleteUser.email}</li>
            <li>前回アクセス：{deleteUser.lastLogin}</li>
            <li>
              ロール：{deleteUser.isAdmin && "Admin"}
              {deleteUser.isProf && " Professional"}
              {deleteUser.isGuest && " Guest"}
            </li>
            <li style={{ textAlign: "center" }}>
              上記のユーザを削除しますか？
            </li>
            <li style={{ display: "flex" }}>
              <Button
                size="small"
                variant="outlined"
                color="secondary"
                style={{ width: "40%", height: "100%", marginRight: "10%" }}
                onClick={DeleteUser}
              >
                削除
              </Button>
              <Button
                size="small"
                variant="outlined"
                color="secondary"
                style={{ width: "40%", height: "100%" }}
                onClick={CancelDeleteUser}
              >
                取消
              </Button>
            </li>
          </ul>
        </div>
      </Modal>

      <PuiMessage
        open={showMessage}
        type={isEmpty(errorMessage) ? "success" : "error"}
        title={isEmpty(errorMessage) ? "同期成功しました" : errorMessage}
        onClose={closeMsg}
      />
    </div>
  );
}
